export enum CardGroup {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  NOT_SET = 'NOT_SET',
  UNKNOWN = 'UNKNOWN',
}

export const getCardGroupLabel = (group: CardGroup) => {
  switch (group) {
    case CardGroup.A:
      return '0%'
    case CardGroup.B:
      return '1.5%'
    case CardGroup.C:
      return '1.95%'
    case CardGroup.D:
      return '1.8%'
    case CardGroup.E:
      return '0.5%'
    case CardGroup.F:
      return '2.45%'
    case CardGroup.NOT_SET:
      return 'Not set'
    case CardGroup.UNKNOWN:
      return 'Unknown'
  }
}

const unique = <T>(array: T[]) => Array.from(new Set(array))

export const cardGroupOptions = (() => {
  const allValues = Object.values(CardGroup)

  // From smallest % to biggest, with NOT_SET and UNKNOWN at the end
  const order = unique([
    CardGroup.A,
    CardGroup.E,
    CardGroup.B,
    CardGroup.D,
    CardGroup.C,
    CardGroup.F,
    CardGroup.NOT_SET,
    CardGroup.UNKNOWN,
    ...allValues,
  ])

  const disabledOptions = [CardGroup.UNKNOWN]

  return order.map((value) => ({
    value,
    label: getCardGroupLabel(value),
    disabled: disabledOptions.includes(value),
  }))
})()

export interface CardGroupData {
  group: CardGroup
  isOverridden: boolean
}
